import type * as React from "react"
import { cn } from "@/lib/utils"
import type { LucideIcon } from "lucide-react"

interface SidebarMenuButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // Accept either a LucideIcon or a React component that takes SVG props
  icon: LucideIcon | React.ComponentType<React.SVGProps<SVGSVGElement>>
  active?: boolean
}

export function SidebarMenuButton({
  className,
  children,
  icon: Icon,
  active,
  ...props
}: SidebarMenuButtonProps) {
  return (
    <button
      className={cn(
        "flex w-full items-center gap-3 rounded-md p-1.5 px-3 text-left text-sm font-normal transition-colors",
        "hover:bg-gray-100 dark:hover:bg-gray-800",
        active && "bg-gray-100 dark:bg-gray-800",
        className,
      )}
      {...props}
    >
      <Icon className="h-5 w-5 flex-shrink-0" />
      <span>{children}</span>
    </button>
  )
}
